import {all, call, put, takeLatest} from 'redux-saga/effects';
import * as constants from '../constants';
import * as engineApi from '../services/engineApi';
import * as actions from '../actions/action_survey';

export function* surveyCreateRequested({payload}) {
    try {
        const response = yield call(engineApi.createSurveyInstance, payload.id, payload.extra);
        yield put(actions.createSurveyInstanceSuccess(payload.id, response.data.id));
    } catch (error) {
        yield put(actions.createSurveyInstanceFailure(error));
    }
}

export function* trackedSurveyCreateRequested({payload}) {
    try {
        const response = yield call(engineApi.createTrackedSurveyInstance, payload.code, payload.extra);
        yield put(actions.createSurveyInstanceSuccess(payload.id, response.data.id));
    } catch (error) {
        yield put(actions.createSurveyInstanceFailure(error));
    }
}

export function* surveyRequested({payload}) {
    try {
        const response = yield call(engineApi.getSurvey, payload.id);
        yield put(actions.surveySuccess(payload.id, response.data));
    } catch (error) {
        yield put(actions.surveyFailure(payload.id, '' + error));
    }
}

export function* surveyTrackedRequested({payload}) {
    try {
        const response = yield call(engineApi.getTrackedSurvey, payload.code);
        yield put(actions.surveySuccess(payload.id, response.data));
    } catch (error) {
        yield put(actions.surveyFailure(payload.id, '' + error));
    }
}

export default function* surveySagas() {
    yield all([
        takeLatest(constants.SURVEY_CREATE_INSTANCE_REQUESTED, surveyCreateRequested),
        takeLatest(constants.SURVEY_TRACKED_CREATE_INSTANCE_REQUESTED, trackedSurveyCreateRequested),
        takeLatest(constants.SURVEY_REQUESTED, surveyRequested),
        takeLatest(constants.SURVEY_TRACKED_REQUESTED, surveyTrackedRequested),
    ]);
}
